import React, { useEffect, useRef } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../baseurl";

function GoogleLogin() {
  const clientRef = useRef(null);

useEffect(() => {
  /* global google */
  if (window.google) {
    clientRef.current = google.accounts.oauth2.initCodeClient({
      client_id:
        "208505888989-nark7pmsv3bb42r27mpsuq8lot30p5uk.apps.googleusercontent.com",
      scope: "email profile openid",
      ux_mode: "popup",
      callback: async (response) => {
        console.log("Auth Code:", response.code);

        try {
          // Send auth code to backend for token exchange
          const res = await axios.post(`${baseurl}googleLogin`, {
            code: response.code,
          });

          console.log("Backend response:", res.data);

          if (res.data.success && res.data.user) {
            // ✅ Save customer info in localStorage
            localStorage.setItem("customerId", res.data.user.id);
            localStorage.setItem("customerEmail", res.data.user.email);
            localStorage.setItem("customerRole", res.data.user.role);

            // ✅ Show SweetAlert2 toast then reload
            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: "Login successful!",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
              didClose: () => {
                window.location.reload(); // 🔄 reload after toast
              },
            });
          } else {
            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "error",
              title: "Login failed!",
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (err) {
          console.error("Login error:", err);
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "error",
            title: "Something went wrong!",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      },
    });
  }
}, []);


  const handleGoogleLogin = () => {
    if (clientRef.current) clientRef.current.requestCode();
  };

  return (
    <button
      onClick={handleGoogleLogin}
      style={{
        backgroundColor: "#fff",
        border: "1px solid #dadce0",
        borderRadius: "6px",
        padding: "10px 20px",
        fontWeight: "500",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <img
        src="https://developers.google.com/identity/images/g-logo.png"
        alt="Google"
        width="20"
        height="20"
      />
      <span>Sign in with Google</span>
    </button>
  );
}

export default GoogleLogin;
